import React from "react";

interface RenderTooltipContentProps {
  items: string[];
  title: string;
  handleRedirect?: Function;
}

const RenderTooltipContent: React.FC<RenderTooltipContentProps> = ({ items, title, handleRedirect }) => {
  return (
    <div style={{ maxWidth: "240px", maxHeight: "150px", overflowY: "auto", backgroundColor: "#FFFFFF" }}>
      <div style={{ marginBottom: "8px", color: "#7C7C7C" }}>
        {items.length} {title}
        {items.length > 1 ? "s" : ""}
      </div>
      {items.map((item, idx) => (
        <div
          key={idx}
          style={{
            margin: "4px 0",
            color: "#2568E5",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => handleRedirect && handleRedirect(item)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default RenderTooltipContent;
